module.exports = __webpack_public_path__ + "img/paypredict-logo-white.77c16cd4.svg";